import { useTranslation } from "react-i18next";
import { CardNotification, Text } from "@foris/avocado-suite";
import Modal from "@components/modal";
import styles from "./deleteDraftModal.module.scss";

interface DeleteDraftModalProps {
  isSubmitting: boolean;
  /** Already translated message of the last failed attempt. */
  errorMessage?: string | null;
  onCancel: () => void;
  onConfirm: () => void;
}

/**
 * Confirmation before deleting one of the requester's drafts from the proposals Drawer. The parent
 * mounts it only while it is open; a failed attempt keeps it open with the message.
 */
const DeleteDraftModal = ({
  isSubmitting,
  errorMessage,
  onCancel,
  onConfirm,
}: DeleteDraftModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      typeState="confirm"
      show
      title={t("group-proposals.delete-modal.title")}
      textButtonPrincipal={t("group-proposals.delete-modal.confirm")}
      colorButtonPrincipal="danger"
      textButtonSecondary={t("group-proposals.delete-modal.cancel")}
      isLoading={isSubmitting}
      isDisabledButtonPrincipal={isSubmitting}
      onClose={onCancel}
      onClickSecondary={onCancel}
      onClickPrincipal={onConfirm}
    >
      <div className={styles.deleteDraftModal}>
        <Text>{t("group-proposals.delete-modal.description")}</Text>

        {!!errorMessage && (
          <div role="alert">
            <CardNotification state="error" title={errorMessage} outlined />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DeleteDraftModal;
